export enum NoteSubType {
  POSTPONED = "POSTPONED",
  WINES_UNAVAILABLE = "WINES_UNAVAILABLE",
  TO_PRINT = "TO_PRINT",
  WAITING_CUSTOMER = "WAITING_CUSTOMER",
}
